import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Subtle vertical scroll progress indicator on the right edge.
 * Only visible on pages with enough content to scroll.
 */
export default function ScrollIndicator() {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const update = () => {
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = window.innerHeight;
      const scrollable = scrollHeight - clientHeight;

      // Only show if there's meaningful scroll (>50% of viewport)
      if (scrollable < clientHeight * 0.5) {
        setVisible(false);
        return;
      }

      setVisible(true);
      setProgress(Math.min(window.scrollY / scrollable, 1));
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    // Reset and recalculate on route change
    update();

    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <div
      className="fixed right-0 top-0 z-40 h-full w-[3px] pointer-events-none"
      aria-hidden="true"
    >
      <div
        className="w-full bg-primary/40 transition-[height] duration-100 ease-out rounded-b-full"
        style={{ height: `${progress * 100}%` }}
      />
    </div>
  );
}
